import { createContext, useContext, useState } from "react";
import { DefaultShowDeviationDetection } from "lib/consts/inspections/deviationDetection";

export const DeviationDetectionContext = createContext();
DeviationDetectionContext.displayName = "InspectionDeviationDetection";
export const useDeviationDetection = () => useContext(DeviationDetectionContext);

const DeviationDetectionProvider = ({ children }) => {
    const [showDeviationDetection, setShowDeviationDetection] = useState(
        DefaultShowDeviationDetection
    );

    return (
        <DeviationDetectionContext.Provider
            value={{
                showDeviationDetection,
                setShowDeviationDetection,
            }}
        >
            {children}
        </DeviationDetectionContext.Provider>
    );
};

export default DeviationDetectionProvider;
